import { Alert } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Form } from "@/organisms/Form"
import {
  getAgentCoreScopeAgents,
  getAiPolicyScope
} from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"

// Why a policy for specific AgentCore agents may not reach their calls: Kodem
// knows the calling agent only through its agent gateway and session
export const AgentCoreScopeNote = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.form.resources.agentCore"
  })
  const { form } = Form.useForm()
  const { live } = useAiPolicies()
  const agents = getAgentCoreScopeAgents(
    getAiPolicyScope({
      resources: Form.useWatch("resources", form),
      specific_resources: Form.useWatch("specific_resources", form)
    }),
    live?.agentOptions ?? []
  )

  if (!agents.length) return null

  return (
    <Alert
      showIcon
      type="warning"
      title={t("title")}
      description={t("description", {
        agents: agents.map((agent) => agent.label).join(", ")
      })}
    />
  )
}
